function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-application_svg__cls-2{fill:var(--main-color)}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-application_svg__Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.92 27a4.88 4.88 0 01-4.85 4.91H15a4.88 4.88 0 01-4.92-4.84V13a4.88 4.88 0 014.85-4.91H25a4.88 4.88 0 014.92 4.84V13zm-1.58-14a3.29 3.29 0 00-3.26-3.32H15a3.29 3.29 0 00-3.34 3.24V27a3.29 3.29 0 003.26 3.32H25a3.29 3.29 0 003.34-3.24V27z",
  transform: "translate(-10.08 -8.09)",
  fill: "var(--main-color)"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-application_svg__cls-2",
  d: "M3.97 5.16h11.91v1.59H3.97zM3.97 9.13h11.91v1.59H3.97zM3.97 13.1h11.91v1.59H3.97zM3.97 17.07h11.91v1.59H3.97z"
}));

function SvgIconApplication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19.84 23.82"
  }, props), _ref, _ref2);
}

export default SvgIconApplication;